import React from "react";
import PropTypes from "prop-types";

import { Navigation } from "../navigation";

export const Header = ({ children, navigation }) => {
  return (
    <>
      <Navigation navigation={navigation} />
      {children}
    </>
  );
};

Header.propTypes = {
  children: PropTypes.node.isRequired,
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ),
};

Header.defaultProps = {
  navigation: [],
};
